import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { AngularSvgIconModule } from 'angular-svg-icon';

@Component({
  selector: 'app-errorpage',
  templateUrl: './errorpage.component.html',
  styleUrls: ['./errorpage.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [AngularSvgIconModule],
})
export class ErrorpageComponent implements OnInit {
  constructor() {}

  ngOnInit(): void {}
}
